// Real pages from ENGELSK PARAT™ Bind 1 (Gamma Studio), WebP 1512×1890 in Recursos Impultienda (tienda ENGELSK PARAT).
// InsidePages only shows entries with a src. Never use images from another product here.
const IMG_BASE = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/205b2b19-228d-4b45-9ecf-c49cdd83f9e2/';

export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [
  {
    src: `${IMG_BASE}1792721729653_engelskparat-bind1-s01-forside-d4064128.webp`,
    label: 'Bind 1 · Forside',
    title: 'Årsplan og 12 færdige engelsklektioner',
    text: 'Bind 1 samler årsplanerne for 1.–9. klasse og tolv engelsklektioner minut for minut – med kopiark i tre niveauer og facitliste.'
  },
  {
    src: `${IMG_BASE}1792721733066_engelskparat-bind1-s04-arsplan-46af0ff7.webp`,
    label: 'Årsplan · Side 4',
    title: 'Årsplanen for 1.–2. klasse',
    text: 'Et emne for hver måned – fra «Hello! Greetings and names» i august til «Summer holiday words» i juni.'
  },
  {
    src: `${IMG_BASE}1792721736888_engelskparat-bind1-s10-classroom-language-af5f0dfa.webp`,
    label: 'Plakat · Side 10',
    title: 'Classroom language-plakat',
    text: 'Fraser til læreren og eleverne på engelsk – hæng plakaten op, og peg på fraserne i stedet for at oversætte.'
  },
  {
    src: `${IMG_BASE}1792721740771_engelskparat-bind1-s13-lektion1-6fc3f8f7.webp`,
    label: 'Lektion 1 · Side 13',
    title: 'Lektion 1: Hello! Greetings minut for minut',
    text: 'Lærerens side: start 0–10, hoveddel 10–35 og afslutning 35–45 med mål, materialer, lærerens instruktion, nøglefraser og differentiering i 3 niveauer.'
  },
  {
    src: `${IMG_BASE}1792721744697_engelskparat-bind1-s16-kopiark-colours-964ecdc1.webp`,
    label: 'Kopiark · Side 16',
    title: 'Kopiark i tre niveauer: Colour the words',
    text: 'Samme opgave i Level 1, 2 og 3 – hele klassen arbejder med farverne, hver på sit niveau.'
  },
  {
    src: `${IMG_BASE}1792721748640_engelskparat-bind1-s33-lektion11-climate-e5bde3cb.webp`,
    label: 'Lektion 11 · Side 33',
    title: 'Lektion 11: Climate and sustainability',
    text: 'Til 8.–9. klasse: eleverne argumenterer for deres mening i en minidebat med key phrases og differentiering i tre niveauer.'
  }
];
